// extracted by mini-css-extract-plugin
export default {"ProfileWraper":"UserProfile_ProfileWraper__44Sh3","imgHover":"UserProfile_imgHover__tSmg1"};